import { TeachersUIFilters } from '../../../types/TeachersUIFilters';
import { TimeRange } from '../../../types/TimeRange';
import { Availability } from '../../../types/Availability';
import PriceRangeFilter from './PriceRangeFilter/PriceRangeFilter';

export type FilterKey = keyof TeachersUIFilters | 'priceRange';
export type FilterType = 'select' | 'custom';

export interface FilterComponentProps {
  filters: TeachersUIFilters;
  onChange: (filters: Partial<TeachersUIFilters>) => void;
}

type BaseFilterConfig = {
  key: FilterKey;
  type: FilterType;
  label: string;
  hide?: boolean;
};

// Select filter
export type SelectFilterConfig = BaseFilterConfig & {
  type: 'select';
  key: keyof TeachersUIFilters;
  multiSelect: boolean;
  options: string[];
  displayMap?: Record<string, string>;
};

// Custom filter
export type CustomFilterConfig = BaseFilterConfig & {
  type: 'custom';
  customComponent: React.FC<FilterComponentProps>;
  customFilterKeys: (keyof TeachersUIFilters)[];
};

export type FilterConfig = SelectFilterConfig | CustomFilterConfig;

export const filtersConfig: FilterConfig[] = [
  {
    key: 'availability',
    type: 'select',
    label: 'Disponibilidad',
    options: [
      Availability.NEXT_48_HOURS,
      Availability.THIS_WEEK,
      Availability.NEXT_2_WEEKS,
      Availability.NEXT_30_DAYS
    ],
    multiSelect: false,
    displayMap: {
      NEXT_48_HOURS: 'Próximas 48h',
      THIS_WEEK: 'Esta semana',
      NEXT_2_WEEKS: 'Próximos 15 dias',
      NEXT_30_DAYS: 'Próximos 30 días'
    }
  },
  {
    key: 'modality',
    type: 'select',
    hide: true,
    label: 'Modalidad',
    options: ['online', 'presencial'],
    multiSelect: false,
    displayMap: {
      online: 'Online',
      presencial: 'Presencial'
    }
  },
  {
    key: 'daysOfWeek',
    type: 'select',
    label: 'Día',
    options: ['1', '2', '3', '4', '5', '6', '0'],
    multiSelect: true,
    displayMap: {
      '0': 'Domingo',
      '1': 'Lunes',
      '2': 'Martes',
      '3': 'Miércoles',
      '4': 'Jueves',
      '5': 'Viernes',
      '6': 'Sábado'
    }
  },
  {
    key: 'timeRanges',
    type: 'select',
    label: 'Horario',
    options: [TimeRange.MORNING, TimeRange.AFTERNOON, TimeRange.EVENING],
    multiSelect: true,
    displayMap: {
      MORNING: 'Mañana',
      AFTERNOON: 'Tarde',
      EVENING: 'Noche'
    }
  },
  {
    key: 'priceRange',
    type: 'custom',
    label: 'Precio por hora',
    customComponent: PriceRangeFilter,
    customFilterKeys: ['minPricePerHour', 'maxPricePerHour']
  }
];
